import React, { useEffect, useState } from "react";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import TimeAgo from "../header/time";
import noData from "../../assets/images/no-data.png";
const LastConsultation = ({ data }) => {
  const [languageData, setLanguageData] = useState(null);
  const [cookieLang, setCookieLang] = useState("");

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      setCookieLang(cookieLang);
      import(`../../lang/dashboard/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <>
      <div className="col-xl-4 col-lg-6 col-sm-6 px-cd-1">
        <div className="card custom-card">
          <div className="card-body h-100">
            <div className="flex-1">
              <div className="d-flex align-items-start justify-content-between">
                <span className="mb-0 flex-1 fs-14">
                  {languageData.indicators.last_consultation}
                </span>
                <div className="ms-2">
                  <span className="avatar bg-warning-transparent text-warning">
                    <i className="bi bi-calendar-heart fs-16"></i>
                  </span>
                </div>
              </div>
              {data.favorite_expert ? (
                <h3 className="mb-0 fs-18">{data.last_consutation}</h3>
              ) : (
                <span className="mb-0 fs-18 font-15 ">
                  {" "}
                ⚊
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LastConsultation;
